import { HttpMethod, type IHttpClient } from '@/shared/contracts/http-client.contract';
import type { IUseCase } from '@/shared/contracts/use-case.contract';

import type { Request, Response } from '../type/get-profile';
import { ENDPOINT } from '../type/get-profile';

type UseCaseInput = Request;
type UseCaseOutput = Response;

export class GetProfileUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(): Promise<UseCaseOutput> {
    return this.client.sendRequest<UseCaseOutput, UseCaseInput>({
      method: HttpMethod.GET,
      endpoint: ENDPOINT,
    });
  }
}
